"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SKIP_LOAD_DESCRIPTIONS_SKU_THRESHOLD = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _reactIntl = require("react-intl");

var _difference = _interopRequireDefault(require("lodash/difference"));

var _SelectedSkuBin = _interopRequireDefault(require("./SelectedSkuBin/SelectedSkuBin"));

var _SkuSearch = _interopRequireDefault(require("./SkuSearch/SkuSearch"));

var _SkuCard = require("./SkuCard/SkuCard");

var _services = require("./services");

var _withI18n = _interopRequireDefault(require("../i18n/withI18n"));

var SKIP_LOAD_DESCRIPTIONS_SKU_THRESHOLD = 500;
exports.SKIP_LOAD_DESCRIPTIONS_SKU_THRESHOLD = SKIP_LOAD_DESCRIPTIONS_SKU_THRESHOLD;

var SkuSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SkuSelector, _PureComponent);

  function SkuSelector() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SkuSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SkuSelector)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.bulkAddSkus =
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(skus) {
        var _this$props, addNonExistentSkus, marketable, onBulkAddSkus, onGetAccessToken, skipLoadDescriptionsForBulkAddSkus, formatMessage, errorSkus, skuMap, errorMessage, _ref2, newSkuMap, oldSkus, newSkus, filteredSkus;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, addNonExistentSkus = _this$props.addNonExistentSkus, marketable = _this$props.marketable, onBulkAddSkus = _this$props.onBulkAddSkus, onGetAccessToken = _this$props.onGetAccessToken, skipLoadDescriptionsForBulkAddSkus = _this$props.skipLoadDescriptionsForBulkAddSkus, formatMessage = _this$props.intl.formatMessage;
                errorSkus = [];

                if (!(skipLoadDescriptionsForBulkAddSkus && skus.length > SKIP_LOAD_DESCRIPTIONS_SKU_THRESHOLD)) {
                  _context.next = 6;
                  break;
                }

                skuMap = skus.reduce(function (map, sku) {
                  map[sku] = {
                    sku: sku
                  };
                  return map;
                }, {});
                _context.next = 12;
                break;

              case 6:
                _context.next = 8;
                return (0, _services.getSkuInfoMapWithSkuList)(skus, onGetAccessToken, marketable, addNonExistentSkus, 500, 5, formatMessage);

              case 8:
                _ref2 = _context.sent;
                skuMap = _ref2.skuMap;
                errorSkus = _ref2.nonExistentSkuList;
                errorMessage = _ref2.error;

              case 12:
                if (errorMessage) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 13;
                _context.next = 16;
                return Promise.resolve(onBulkAddSkus(skuMap));

              case 16:
                newSkuMap = _context.sent;
                oldSkus = Object.keys(skuMap);
                newSkus = newSkuMap ? Object.keys(newSkuMap) : oldSkus;
                filteredSkus = (0, _difference.default)(oldSkus, newSkus);
                errorSkus = errorSkus.concat(filteredSkus);
                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](13);
                errorMessage = _context.t0;

              case 26:
                return _context.abrupt("return", errorSkus && errorSkus.length ? errorSkus : errorMessage);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[13, 23]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.bulkRemoveSkus = function (skus) {
      var _this$props2 = _this.props,
          onBulkRemoveSkus = _this$props2.onBulkRemoveSkus,
          unremoveableSkuList = _this$props2.unremoveableSkuList;
      var errorList = [];
      var unremoveableSkuMap = unremoveableSkuList.reduce(function (unremoveableSkus, unremoveableSku) {
        unremoveableSkus[unremoveableSku] = unremoveableSku;
        return unremoveableSkus;
      }, {});
      var bulkSkuList = skus.filter(function (sku) {
        if (unremoveableSkuMap[sku]) {
          errorList.push(sku);
          return false;
        }

        return true;
      });
      onBulkRemoveSkus(bulkSkuList);
      return errorList;
    };

    return _this;
  }

  (0, _createClass2.default)(SkuSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          preselectedSkuList = _this$props3.preselectedSkuList,
          onPreselectedSkusLoadStarted = _this$props3.onPreselectedSkusLoadStarted,
          onPreselectedSkusLoaded = _this$props3.onPreselectedSkusLoaded; // If a list of skus is passed to the selector, prepopulate names, descriptions, and scene urls for them.

      if (preselectedSkuList) {
        onPreselectedSkusLoadStarted && onPreselectedSkusLoadStarted();
        this.bulkAddSkus(preselectedSkuList, true).then(function () {
          return onPreselectedSkusLoaded && onPreselectedSkusLoaded();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          onFetch = _this$props4.onFetch,
          disabled = _this$props4.disabled,
          skuSearchSectionTitle = _this$props4.skuSearchSectionTitle,
          skuBinSectionTitle = _this$props4.skuBinSectionTitle,
          skuBinClickable = _this$props4.skuBinClickable,
          selectedSkus = _this$props4.selectedSkus,
          unremoveableSkuList = _this$props4.unremoveableSkuList,
          unremoveableTooltipMessage = _this$props4.unremoveableTooltipMessage,
          onAddSku = _this$props4.onAddSku,
          onRemoveSku = _this$props4.onRemoveSku,
          accountIds = _this$props4.accountIds,
          onGetAccessToken = _this$props4.onGetAccessToken,
          marketable = _this$props4.marketable,
          skuSearchStyle = _this$props4.skuSearchStyle,
          selectedSkuBinStyle = _this$props4.selectedSkuBinStyle,
          className = _this$props4.className,
          skipLoadDescriptionsForBulkAddSkus = _this$props4.skipLoadDescriptionsForBulkAddSkus,
          skuSelectorSkuCardCustomRenderFn = _this$props4.skuSelectorSkuCardCustomRenderFn,
          selectedSkuBinSkuCardCustomRenderFn = _this$props4.selectedSkuBinSkuCardCustomRenderFn,
          customBulkErrorMessage = _this$props4.customBulkErrorMessage,
          _this$props4$intl = _this$props4.intl;
      _this$props4$intl = _this$props4$intl === void 0 ? this.props : _this$props4$intl;
      var locale = _this$props4$intl.locale;
      var renderHeaders = skuSearchSectionTitle || skuBinSectionTitle;
      return _react.default.createElement("div", {
        className: "sku-selector row"
      }, _react.default.createElement("div", {
        className: "sku-selector__section col-sm-12 col-md-6"
      }, renderHeaders ? _react.default.createElement("h4", {
        className: "sku-selector__section-heading"
      }, skuSearchSectionTitle) : null, _react.default.createElement(_SkuSearch.default, {
        disabled: disabled,
        accountIds: accountIds,
        excludingSkus: selectedSkus,
        className: "sku-selector__section-skusearch ".concat(className || ''),
        resultsClassName: "sku-selector__section-skusearch-results",
        onAddAction: onAddSku,
        bulkAddSkus: this.bulkAddSkus,
        skipLoadDescriptionsForBulkAddSkus: skipLoadDescriptionsForBulkAddSkus,
        onGetAccessToken: onGetAccessToken,
        marketable: marketable,
        style: skuSearchStyle,
        skuCardCustomRenderFn: skuSelectorSkuCardCustomRenderFn,
        onFetch: onFetch,
        customBulkErrorMessage: customBulkErrorMessage
      })), _react.default.createElement("div", {
        className: "sku-selector__section col-sm-12 col-md-6"
      }, renderHeaders ? _react.default.createElement("h4", {
        className: "sku-selector__section-heading"
      }, skuBinSectionTitle) : null, _react.default.createElement(_SelectedSkuBin.default, {
        locale: locale,
        disabled: disabled,
        clickable: skuBinClickable,
        className: "sku-selector__section-skubin ".concat(className || ''),
        skus: selectedSkus,
        unactionableSkuList: unremoveableSkuList,
        unactionableTooltipMessage: unremoveableTooltipMessage,
        hasAction: true,
        actionIcon: "bin-1-f",
        onAction: onRemoveSku,
        bulkRemoveSkus: this.bulkRemoveSkus,
        style: selectedSkuBinStyle,
        skuCardCustomRenderFn: selectedSkuBinSkuCardCustomRenderFn,
        customBulkErrorMessage: customBulkErrorMessage
      })));
    }
  }]);
  return SkuSelector;
}(_react.PureComponent);

SkuSelector.defaultProps = {
  disabled: false,
  marketable: true,
  skuBinClickable: false,
  skipLoadDescriptionsForBulkAddSkus: false
};

var _default = (0, _withI18n.default)((0, _reactIntl.injectIntl)(SkuSelector));

exports.default = _default;